import React from 'react';
import { isEqual } from 'date-fns';
import {Alert} from '@material-ui/lab';
import {Avatar, Box, Card, CardContent, CardHeader, List, ListItem, ListItemText} from "@material-ui/core";
import AccountTreeIcon from '@material-ui/icons/AccountTree';

const PingTreeCard = ({pingTrees, vendorPauses, cardClasses}) =>  {
    const activeVendorPauses = vendorPauses.filter(item => {
        if (item.startDate) {
            return isEqual(item.startDate, new Date());
        }
        return item;
    });
    return (
        <Card component={Card} className={cardClasses.card}>
            <div>
                <CardHeader
                    avatar={
                        <Avatar aria-label="type" className={cardClasses.contact}>
                            <AccountTreeIcon/>
                        </Avatar>
                    }
                    title="Ping Trees"
                    subheader={''}
                />
                <CardContent>
                    {activeVendorPauses.length ? (
                        <Alert severity="warning" style={{ marginBottom: '10px'}}>
                            <Box>
                                <strong>Please Note:</strong> The campaign is paused, refer to the vendor pause card
                                or the <a href="#" onClick={(e) => {
                                e.preventDefault();
                                window.open('/info/vendor-pause');
                            }}>vendor pause page.</a>
                            </Box>
                        </Alert>
                    ) : null}
                    {pingTrees.length ? (
                        <List>
                            {pingTrees.map(item => (
                                <ListItem key={item.id}>
                                    <ListItemText>
                                        {item.name}
                                    </ListItemText>
                                </ListItem>
                            ))}
                        </List>
                    ) : (
                        <Alert severity="warning">Currently, this campaign is not active in any trees.</Alert>
                    )}
                </CardContent>
            </div>
        </Card>
    );
};

export default PingTreeCard;
